import { Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import "./searchBar.scss";
// import { makeStyles } from "@mui/styles";

// const useStyles = makeStyles({
//   searchStyleTC: {
//     background: "#2C2C2C",
//     borderRadius: 50,
//     minHeight: "31px",
//   },
// });

const SearchBar = ({ searchChange }) => {
  // const stylesTC = useStyles();
  const [text, setText] = useState("");

  const handleChange = (event) => {
    setText(event.target.value);
    searchChange(event.target.value);
  };

  // useEffect(() => {
  // 	searchChange(text);
  // }, [text]);

  return (
    <>
      <Stack>
        <TextField
          onChange={handleChange}
          value={text}
          placeholder="Search"
          variant="filled"
          className={"searchStyleTC"}
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <InputAdornment>
                <IconButton></IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </>
  );
};

export default SearchBar;
